export enum SourceEnum {
  Upload = "upload",
  Output = "output",
  Pdb = "PDB",
  Afdb = "AF_DB",
}
